import { RulebookModel } from '.';

export class ItemInfoDto {
    rulebooks: Array<string>;
    jurisdictions: Array<string>;
    rulebookList: Array<RulebookModel>;
    rulebookInfo: RulebookModel;
    id: number;
    regulationDetailId: number;
    idList: Array<number>;
    screenUrl: string;
    itemType: string;
    jurisdiction:string;
    jurisdictionId:number;
    templateNo:number;

    constructor() {
        this.rulebooks = [];
        this.jurisdictions = [];
        this.rulebookList = [];
        this.rulebookInfo = new RulebookModel();
        this.id = 0;
        this.regulationDetailId = 0;
        this.idList = [];
        this.screenUrl = '';
        this.itemType = '';
        this.jurisdiction = '';
        this.jurisdictionId = 0;
        this.templateNo = 0;
    }
}
